<script src="../request/request.js"></script>
<template>
  <div>
    <div class="header">账号注册</div>
    <div class="items-box">
      <div class="items">
        <img src="../../regiest/1.png" class="icons" />
        <div class="items-right">
          <div>手机号码</div>
          <input
            type="number"
            v-model="info.number"
            placeholder="请输入手机号码"
            class="inputs"
          />
        </div>
      </div>
      <div class="items m-t-30">
        <img src="../../regiest/2.png" class="icons2" />
        <div class="items-right">
          <div>请设置密码</div>
          <input
            type="password"
            v-model="info.password"
            placeholder="请输入6-14位密码"
            class="inputs"
          />
        </div>
      </div>
      <div class="items code-style m-t-30">
        <div style="display: flex">
          <img src="../../regiest/3.png" class="icons2" />
          <div class="items-right">
            <div>请输入验证码</div>
            <input
              type="text"
              v-model="info.code"
              placeholder="请输入验证码"
              class="inputs"
            />
          </div>
        </div>
        <div v-show="!codeShow">
          <span class="code-text">验证码发送成功</span>
          <span class="code-num">{{ code }}</span>
        </div>
        <span class="set-code" @click="sendCode" v-show="codeShow">
          发送验证码
        </span>
      </div>
      <div class="items m-t-30">
        <img src="../../regiest/4.png" class="icons2" />
        <div class="items-right">
          <div>邀请码</div>
          <input
            type="text"
            v-model="info.teacherId"
            placeholder="请输入邀请码"
            class="inputs"
          />
        </div>
      </div>
    </div>
    <div class="btn1" @click="btnClick">点击注册</div>
    <div class="btn2" @click="jump">已是老用户，点击下载</div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      timer: null,
      codeShow: true,
      code: 60,
      info: {},
    };
  },
  created(){
    console.log(this.$route.query.refCode)
    this.info.teacherId = this.$route.query.refCode;
    // this.getUrlParmar("phone");
    // this.getQueryString(window.location.href);
  },
  methods: {
    getUrlParmar(paraName) {
      var url = document.location.toString();
      var arrObj = url.split("?");
      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;
        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");
          if (arr != null && arr[0] == paraName) {
            console.log(arr[1]);
            this.info.teacherId = arr[1].substring(0, arr[1].length - 2);

          }
        }
        return "";
      } else {
        return "";
      }
    },
    btnClick(){
      let that = this;
      if (!this.info.number) {
        alert('请输入手机号码!');
        return false;
      }
      if (!this.info.password) {
        alert('请输入密码!');
        return false;
      }
      if (!this.info.code) {
        alert('请输入验证码!');
        return false;
      }
      if (!this.info.teacherId) {
        alert('请输入邀请码!');
        return false;
      }
      const config = {
        // headers:{
        //   'Content-Type':'multipart/form-data',
        // }
      };
      axios.post('https://wifi.midianshangmeng.com/api/auth/oauth/registerByWeb', {
        mobile: this.info.number,
        password: this.info.password,
        refCode: this.info.teacherId,
        code: this.info.code
      },config)
      .then(function (res) {
        if(res.data.code === 200){
          alert('注册成功');
          // that.setCode();
          that.androidClick();
        }else{
          alert(res.data.msg);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    sendCode(){
      let that = this;
      if (!this.info.number) {
        alert('请输入手机号码!');
        return false;
      }
      if(this.codeShow){
        const config = {
          // headers:{
          //   'Content-Type':'multipart/form-data',
          // }
        };
        axios.post('https://wifi.midianshangmeng.com/api/system/smsMessage/registerSms',{
          mobile: this.info.number,
          mbrSmsType:'00'
        }, config)
          .then(function (res) {
            if(res.data.code === 200){
              alert('发送成功，请注意查收');
              that.setCode()
            }else{
              alert(res.data.msg);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    jump() {
      this.$router.push({
        path: "/index",
      });
    },
    setCode() {
      this.codeShow = false;
      this.timer = setInterval(() => {
        this.code--;
        if (this.code === -1) {
          this.code = 60;
          this.codeShow = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    androidClick(){
      const config = {
        // headers:{
        //   'Content-Type':'multipart/form-data',
        // }
      };
      axios.post('https://wifi.midianshangmeng.com/api/system/appVersionInfo/latestVersion', {
        appId: '__UNI__C268F0C',
        osType: '0',
      }, config)
          .then(function (res) {
            if(res.data.code === 200){
              let result = res.data.data
              console.log(result)
              window.location.href=result.url
            }else{
              alert(res.data.msg);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      // window.location.href="https://dashare.addior.cn/apk/v1.0.0_20211105_161035.apk"
    },
  },
};
</script>

<style scoped>
.code-text {
  color: #89acfd;
  font-size: 12px;
}
.code-num {
  color: #89acfd;
  border-radius: 50%;
  border: 1px solid #89acfd;
  width: 20px;
  height: 20px;
  display: inline-block;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  margin-left: 10px;
}
.btn1 {
  background: linear-gradient(#6f8cf5,#89acfd);
  color: #fff;
  width: 70%;
  margin: 50px auto 10px auto;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
  font-size: 18px;
}
.set-code {
  background: #89acfd;
  color: #fff;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  font-size: 12px;
}
.btn2 {
  background: #fff;
  border: 1px solid #89acfd;
  color: #89acfd;
  width: 70%;
  margin: 0 auto;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
  font-size: 18px;
}
.code-style {
  display: flex;
  justify-content: space-between;
}
.header {
  background: linear-gradient(#6f8cf5,#89acfd);
  color: #fff;
  width: 100%;
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
}
.items-box {
  margin-top: 75px;
}
.items {
  border-bottom: 1px solid #bdbdbe;
  width: 80%;
  margin: 0 auto;
  display: flex;
}
.items-right {
  margin-left: 15px;
}
.m-t-30 {
  margin-top: 30px;
}
.icons {
  width: 20px;
  height: 30px;
}
.icons2 {
  width: 20px;
  height: 22px;
}
.inputs {
  border: none;
  margin: 10px 0;
}
input:focus {
  outline: none;
}
</style>
